"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isBaseEmote = exports.isBaseAvatar = exports.requiredBaseItemProps = exports.baseItemProperties = void 0;
const i18n_1 = require("./i18n");
const metrics_1 = require("./metrics");
const displayable_1 = require("../shared/displayable");
// @internal
exports.baseItemProperties = Object.assign(Object.assign({}, displayable_1.displayableProperties), { id: {
        type: 'string'
    }, name: {
        type: 'string'
    }, description: {
        type: 'string'
    }, i18n: {
        type: 'array',
        items: i18n_1.I18N.schema,
        minItems: 1,
        uniqueItemProperties: ['code'],
        errorMessage: '${0#} array should not have duplicates for "code"'
    }, thumbnail: {
        type: 'string'
    }, image: {
        type: 'string'
    }, metrics: Object.assign(Object.assign({}, metrics_1.Metrics.schema), { nullable: true }) });
exports.requiredBaseItemProps = ['id', 'name', 'description', 'i18n', 'thumbnail', 'image'];
function isBaseAvatar(item) {
    if (!item || !item.id) {
        return false;
    }
    const urnParts = item.id.split(':');
    const isDecentralandAvatar = urnParts[1] === 'decentraland';
    const isBaseAvatar = urnParts[3] === 'base-avatars';
    return urnParts.length === 5 && isDecentralandAvatar && isBaseAvatar;
}
exports.isBaseAvatar = isBaseAvatar;
function isBaseEmote(item) {
    if (!item || !item.id) {
        return false;
    }
    const urnParts = item.id.split(':');
    return urnParts.length === 5 && urnParts[1] === 'decentraland' && urnParts[3] === 'base-emotes';
}
exports.isBaseEmote = isBaseEmote;
//# sourceMappingURL=base-item.js.map